module.exports = __webpack_public_path__ + "img/TV_clean_box21.8868e51d.jpg";